import fastdom from 'fastdom';

/**
 * This component is intended to build a skeleton card or a set of skeleton cards and place it in a given container.
 */
export default class CardGridSkeleton {
  constructor() {
    this.skeletonCustomDataValue = 'data-skeleton-card';
    this.containerSelector = null;
    this.cardCount = 8;
  }

  /**
   * create: creates a set of card skeletons and places them in a given container.
   */
  create() {
    fastdom.mutate(() => {
      const container = document.querySelector(this.containerSelector);

      if (container) {
        container.innerHTML = this.getCardSkeleton();
      }
    });
  }

  /**
   * concat: creates a set of card skeletons and appends them in a given container.
   */
  concat() {
    const container = document.querySelector(this.containerSelector);

    if (container) {
      const skeletonElements = document.createRange().createContextualFragment(this.getCardSkeleton());
      container.appendChild(skeletonElements);
    }
  }

  /**
   * getSkeletonCardNodes: retrieves the skeleton cards from a given container.
   * @returns a node list filled with skeleton card nodes.
   */
  getSkeletonCardNodes() {
    const container = document.querySelector(this.containerSelector);
    return container?.querySelectorAll(`[${this.skeletonCustomDataValue}]`);
  }

  /**
   * destroy: destroys the skeleton set from a given container.
   */
  destroy() {
    fastdom.mutate(() => {
      const skeletonElements = this.getSkeletonCardNodes();

      skeletonElements?.forEach((card) => {
        card.parentElement.removeChild(card);
      });
    });
  }

  /**
   * getCardSkeleton: builds and returns a string representing the skeleton cards to show.
   * @returns an string ready to create HTML nodes representing card grid skeletons.
   */
  getCardSkeleton() {
    const cardList = Array.from({ length: this.cardCount }, () => this.getCardHtml()).join('');
    return cardList;
  }

  /**
   * getCardHtml: builds and returns a string representing the template of a card skeleton.
   * @returns a card skeleton string ready to be used to create a HTML node.
   */
  getCardHtml() {
    return `<div ${this.skeletonCustomDataValue} class="card-skeleton card">
          <div class="skeleton__images">
          </div>
          <div class="placeholder-item">
              <div class="animated-background">
                  <div class="bg-mask title-top"></div>
                  <div class="bg-mask title-left"></div>
                  <div class="bg-mask title-right"></div>
                  <div class="bg-mask title-bottom"></div>

                  <div class="bg-mask builder-left"></div>
                  <div class="bg-mask builder-right"></div>
                  <div class="bg-mask builder-bottom"></div>

                  <div class="bg-mask comm-left"></div>
                  <div class="bg-mask comm-right"></div>
                  <div class="bg-mask comm-bottom"></div>

                  <div class="bg-mask bed-left"></div>
                  <div class="bg-mask bath-right"></div>
                  <div class="bg-mask price-right"></div>
                  <div class="bg-mask button-bottom"></div>
                  <div class="bg-mask button-left"></div>
                  <div class="bg-mask button-right"></div>
                  <div class="bg-mask price-bottom"></div>
              </div>
          </div>
        </div>`;
  }
}
